import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  SubscriptionCheckoutSession,
  MutationCreateSubscriptionCheckoutSessionArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateSubscriptionCheckoutSession = (options?: {
  useMutationOptions?: UseMutationOptions<
    SubscriptionCheckoutSession,
    ClientError,
    MutationCreateSubscriptionCheckoutSessionArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    SubscriptionCheckoutSession,
    ClientError,
    MutationCreateSubscriptionCheckoutSessionArgs
  >(
    input =>
      client.mutation({
        name: 'createSubscriptionCheckoutSession',
        args: {
          fields: 'basic',
          variables: input,
        },
      }),
    useMutationOptions,
  )
}
